import React, { useEffect } from "react";
import { useAccountModel } from "./accountModel";
import { Button, message } from "antd";
import { YhBox } from "@/components/YhBox";
import { AccountDataTable } from "./DataTable";
import { OpenAccountDrawer } from "./OpenAccountDrawer";
import { AdjustDrawer } from "./AdjustDrawer";
import { RechargeDrawer } from "./RechargeDrawer";
import { TransferDrawer } from "./TransferDrawer";
import { WriteoffDrawer } from "./WriteoffDrawer";
import { useDetailModel } from "../detailModel";
import { accountService } from "../../../../AccountService";
import { dictService } from "../../../../../base/dict/dictService";

export const AccountDataBox = () => {
    const {
        customerCode,
        state,
        selectedRowKeys,
        onReset,
        dataSource,
        setOpenDrawerVisible,
        setAdjustDrawerVisible,
        setRechargeDrawerVisible,
        setTransferDrawerVisible,
        setWriteoffDrawerVisible,
        loadData,
        setSelectedData,
        setCustomerUserList,
        setCustomerUserDs,
        setAccountType
    } = useAccountModel();


    useEffect(() => {
        loadData({ pageNum: 1 }).then()
        dictService.dictItemDs('account-type').then(ds => setAccountType(ds))
    }, [state])
    
    useEffect(() => {
        let filters = dataSource.filter(el => selectedRowKeys.length > 0 ? el.key === selectedRowKeys[0] : false);
        const selectedData = filters && filters.length > 0 ? filters[0] : undefined;
        setSelectedData(selectedData)
        accountService.find({ partnerCode: customerCode }).then(result => {
            setCustomerUserList(result.retData)
            setCustomerUserDs(
                result.retData.map(item => {
                    return {
                        label: item.name ?? '',
                        value: item.code ?? ''
                    }
                })

            )
        })
    }, [selectedRowKeys]);
    const onOpenAccount = () => {
        setOpenDrawerVisible(true);
    }
    const onAdjust = () => {
        if (selectedRowKeys && selectedRowKeys.length > 0) {
            setAdjustDrawerVisible(true);
        } else {
            message.error("请选择调额账户!");
        }
    }
    const onRecharge = () => {
        if (selectedRowKeys && selectedRowKeys.length > 0) {
            setRechargeDrawerVisible(true);
        } else {
            message.error("请选择充值账户!");
        }
    }
    const onTransfer = () => {
        if (selectedRowKeys && selectedRowKeys.length > 0) {
            setTransferDrawerVisible(true);
        } else {
            message.error("请选择转出账户!");
        }
    }

    const onWriteoff = () => {
        if (selectedRowKeys && selectedRowKeys.length > 0) {
            setWriteoffDrawerVisible(true);
        } else {
            message.error("请选择核销账户!");
        }
    }


    const action = (
        <>
            <div>
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    onClick={onOpenAccount}
                >
                    开户
                </Button>
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    onClick={onAdjust}
                >
                    调额
                </Button>
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    onClick={onRecharge}
                >
                    充值
                </Button>
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    onClick={onTransfer}
                >
                    转账
                </Button>
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    onClick={onWriteoff}
                >
                    核销账单
                </Button>
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    onClick={onReset}
                >
                    刷新
                </Button>
            </div>

        </>
    );

    return (
        <>
            <YhBox title={"账户列表"} action={action}>
                <AccountDataTable />
            </YhBox>
            <OpenAccountDrawer />
            <AdjustDrawer />
            <RechargeDrawer />
            <TransferDrawer />
            <WriteoffDrawer />
        </>
    )
}
